export default __webpack_public_path__ + "static/nr1_screenshot-full_Find-user-activity-data-in-nrql-903094b862953fb54cf889af6378b4b3.webp";